// extracted by mini-css-extract-plugin
export default {"seoHeader":"SeoHeader_seoHeader__OTE1M"};